// Voice-funnel beacons (plan §5.3) — first-party statistics through the
// /asosevent whitelist, NOT consent-gated (no cookies, no third party).
// Whitelist discipline: asosevent.php silently drops unlisted events, and the
// API-side whitelist is extended in the same commit that adds a name here.
//
//   voice_start     — the conversation actually began (entrance tap completed)
//   voice_micdenied — mic permission denied → typed fallback engaged
//   voice_handoff   — the call path opened mid-flow (draft card shown or the
//                     assistant offered „Hívás")
import apiClient from '../api/client'

export type VoiceEventName = 'voice_start' | 'voice_micdenied' | 'voice_handoff'

const sent = new Set<VoiceEventName>()

/** Fire-and-forget, once per page load per event name. /asosevent is a GET
    beacon (query param), matching the API route. */
export function voiceEvent(name: VoiceEventName): void {
	if (sent.has(name)) return
	sent.add(name)
	apiClient.get('/asosevent', { params: { event: name } }).catch(() => {})
}

/**
 * Diagnostics rail (voice_diag → statistics, session-linked): the browser is
 * where every conversation failure lives, and until now none of it was
 * visible server-side. kind:detail lands in statistics.label — queryable per
 * session, so "it misbehaved" becomes replayable. Capped per page load so a
 * hot loop cannot spray the table.
 */
let diagBudget = 40

export function logDiag(kind: string, detail = ''): void {
	if (diagBudget <= 0) return
	diagBudget--
	const label = `${kind}${detail ? `: ${detail}` : ''}`.slice(0, 250)
	apiClient.get('/asosevent', { params: { event: 'voice_diag', label } }).catch(() => {})
}
